"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
function Logos(_a) {
    var channel = _a.channel;
    var teams = ra_fetch_1.useApi('backend').index('teams', {
        competition_id: channel.id,
        hidden_channel: 0,
        sort: 'channels.name asc',
    })[0];
    return react_1.default.createElement("div", { className: 'storybook-channels-show-teams' }, teams.data.filter(function (team) { return team.club.icon; }).map(function (team, index) { return (react_1.default.createElement("a", { key: index, title: team.club.label, href: process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/kanalen/" + team.club.name },
        react_1.default.createElement("img", { src: team.club.icon, alt: team.club.label }))); }));
}
exports.default = Logos;
